import React from 'react';
import PropTypes from 'prop-types';
import { clsx as cx } from 'clsx';
import Icon from '../icon';
import { MenuLabel } from '../main-menu/main-menu.css';

function NotificationsMenu(props) {
	const {
		hasUnread = false,
		isActive = false,
		isMaximized = false,
		onMenuItemClick
	} = props;

	const handleMenuItemClick = () => {
		onMenuItemClick();
	};

	return (
		<div data-tooltip="Notifications" data-tooltip-position="right">
			<div
				className={cx(
					'nav-row notifications-menu',
					'relative flex items-center flex-nowrap',
					'transition-colors duration-fast cursor-pointer',
					'text-sm font-bold',
					'hover:bg-nav-hover hover:text-white',
					isActive ? 'text-white' : 'text-white text-opacity-30',
					{ 'has-unread': hasUnread }
				)}
				onClick={handleMenuItemClick}
			>
				<Icon
					use="bell"
					size={1.25}
					className={cx(
						'notifications-menu__icon',
						isActive ? 'opacity-100' : 'opacity-30'
					)}
					style={{ margin: '1rem 1.375rem' }}
				/>
				<MenuLabel className={isMaximized ? 'block' : 'hidden'}>Notifications</MenuLabel>
			</div>
		</div>
	);
}

NotificationsMenu.propTypes = {
	hasUnread: PropTypes.bool,
	isActive: PropTypes.bool,
	isMaximized: PropTypes.bool,
	onMenuItemClick: PropTypes.func
};

export default NotificationsMenu;
